import { Route, Routes } from 'react-router-dom';
import {
  MaintenanceFormPage,
  MaintenanceListPage,
} from '@/modules/maintenance/pages';
import { maintenancePaths } from '@/modules/maintenance/paths';
import { RequirePermission } from '@/shared/components/RequirePermission';

export function MaintenanceModule() {
  return (
    <Routes>
      <Route index element={<MaintenanceListPage />} />
      <Route
        path={maintenancePaths.taskNew}
        element={
          <RequirePermission permission="maintenance.write">
            <MaintenanceFormPage />
          </RequirePermission>
        }
      />
      <Route path={maintenancePaths.taskDetail} element={<MaintenanceFormPage />} />
    </Routes>
  );
}
